const normalizeComparableNumber = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    if (typeof value === "number") {
        return Number.isNaN(value) ? null : value;
    }

    if (typeof value === "string") {
        const normalized = value.trim().replace(",", ".");
        if (normalized === "") {
            return null;
        }

        const parsed = Number.parseFloat(normalized);
        return Number.isNaN(parsed) ? value : parsed;
    }

    return value;
};

export const canEditPrecioPublicacion = (publicacion, publicacionInicial) => {
    const verifyPrecio = ["precioLista", "precioPromocional", "stock", "alicuotaIva", "alicuotaImpuestoInterno"];
    const compareResults = verifyPrecio.map((item) => {
        const valorActual = publicacion[item];
        const valorInicial = publicacionInicial[item];
        const valorActualNormalizado = normalizeComparableNumber(valorActual);
        const valorInicialNormalizado = normalizeComparableNumber(valorInicial);
        const changed = valorActualNormalizado !== valorInicialNormalizado;

        return {
            campo: item,
            valorActual,
            valorInicial,
            valorActualNormalizado,
            valorInicialNormalizado,
            changed,
        };
    });

    const canEditPrecio = compareResults.some((result) => result.changed);

    // Si el stock cambió a 0, la publicación se pausa automáticamente
    if (publicacion.stock === 0 && publicacion.stock !== publicacionInicial.stock) {
        publicacion.estado = "pausado";
    }
    // Si el stock cambió y ahora es mayor a 0, la publicación se activa automáticamente
    else if (publicacion.stock > 0 && publicacionInicial.stock === 0) {
        publicacion.estado = "activo";
    }

    return canEditPrecio;
}